export default "__VITE_ASSET__BNR62GiX__"